import { memo } from "react";

const BzChip = ({ className, ...props }) => {
    return (
        <div className={className} {...props}>
            {props.children}
        </div>
    )
}

export default memo(BzChip);
